/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import Header from '../../components/header';
import { Route, Switch } from 'react-router-dom';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppLayout } from '../../layout/AppLayout';
import React from 'react';
import { AppRouteInterface, RouteInterface } from '../../types/routes';
import Taxonomy from './Taxonomy';
import PrimaryConnections from './PrimaryConnections';
import { AppHeader } from '../../components/header/AppHeader';
import SDGAPLogo from '../../images/SDGAP_logo.svg';

export const sdgapRouteEntry: RouteInterface = {
  id: 'sdgap_entry',
  label: 'Taxonomy',
  path: '/sdgap/:tool?/:type?/:code?',
  appPermissionId: 'app_sdgap',
  auth: true,
  exact: false,
  component: SdgapRoute
}

export const sdgGapRoute: RouteInterface = {
  id: 'sdgap',
  label: 'Taxonomy',
  tooltip: 'SD(G)AP Taxonomy',
  path: '/sdgap/taxonomy/:type?/:code?',
  appPermissionId: 'app_sdgap',
  icon: 'fa-bullseye',
  component: Taxonomy,
  auth: true,
}

export const sdgGapPrimaryRoute: RouteInterface = {
  id: 'sdgap-primary-connections',
  label: 'Primary Connections',
  tooltip: 'SD(G)AP Primary Connections',
  path: '/sdgap/primary-connections/:type?/:code?',
  appPermissionId: 'app_sdgap',
  icon: 'fa-bullseye',
  component: PrimaryConnections,
  auth: true,
}

const SdgAppRoute: AppRouteInterface = {
  appName: 'SD(G)AP',
  appIcon: SDGAPLogo,
  routes: [sdgGapRoute, sdgGapPrimaryRoute]
}

export function SdgapRoute() {

  const component = (props: any) => (
    <Header {...props} className={'responsivePage'}>
      <AppHeader appRoute={SdgAppRoute} route={sdgGapRoute} />
    </Header>
  );
  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={'/sdgap'} component={component} />}>
        <Switch>
          <Route {...sdgGapRoute} />
          <Route {...sdgGapPrimaryRoute} />
        </Switch>
      </AppLayout>
    </RouteErrorBoundary>
  )
}

